import { useCallback, useEffect, useRef } from "react";

import { useHelpBeaconIsOpen } from "Flocknote/stateHooks";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrNumericIndicator from "UI/FnrNumericIndicator";
import FnrSlides from "UI/FnrSlides";

import {
  useBackgroundManagerStore,
  useShowBackgroundManagerButton,
} from "Utilities/Hooks/useBackgroundManagerHeight";
import {
  useIsFocusVisible,
  useIsHovered,
} from "Utilities/Hooks/useIsHoverFocused";

import ButtonSizer from "./ButtonSizer";
import { hoverTextKeys, useHoverTextKey } from "./accountAndSettingsStore";

const Button = () => {
  const count = useBackgroundManagerStore((s) => s.count);
  const [helpBeaconIsOpen] = useHelpBeaconIsOpen();
  const buttonRef = useRef(null);
  const [, setHoverTextKey] = useHoverTextKey();
  const isHovered = useIsHovered(buttonRef);
  const isFocusVisible = useIsFocusVisible(buttonRef);

  useEffect(() => {
    if (isHovered || isFocusVisible)
      setHoverTextKey(hoverTextKeys.importManager);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHovered, isFocusVisible, setHoverTextKey]);

  const handleClick = useCallback(() => {
    setHoverTextKey(hoverTextKeys.noHover);
    if (helpBeaconIsOpen) window.Beacon("toggle");
    window.backgroundJobCheckerInstance?.showHide();
  }, [helpBeaconIsOpen, setHoverTextKey]);

  return (
    <FnrShineButton
      ref={buttonRef}
      aria-label="open-import-manager"
      onClick={handleClick}
    >
      <ButtonSizer>
        <FnrContainedIcon noPadding color="textLight" icon="file-import fas" />
        <FnrNumericIndicator count={count} show />
      </ButtonSizer>
    </FnrShineButton>
  );
};

const Nothing = () => null;

const config = [
  { key: "nothing", value: Nothing },
  { key: "button", value: Button },
];

const ImportManagerCollapse = () => {
  const show = useShowBackgroundManagerButton();

  return (
    <FnrSlides
      variant="zoom"
      components={config}
      activeKey={show ? "button" : "nothing"}
      clip={false}
    />
  );
};

export default ImportManagerCollapse;
